<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">
      <b>仓库名称：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.name"
                placeholder="请输入仓库名称"/>
      <b>仓库编码：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.code"
                placeholder="请输入仓库编码"/>
      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search"></i>查询</el-button>
      <el-button type="primary" @click="createdata" size="medium" round><i class="el-icon-circle-plus"></i>新建仓库
      </el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>
    </div>
    <el-table v-loading="loading"
              :data="tableData"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column

          label="仓库名称"
          prop="name" align="center">
      </el-table-column>
      <el-table-column

          label="仓库编码"
          prop="code" align="center">
      </el-table-column>
      <el-table-column
          label="负责人"
          prop="principal" align="center">
      </el-table-column>
      <el-table-column
          label=仓库类型  :formatter="formatWarehouseType"
          prop="type" align="center">
      </el-table-column>

      <el-table-column
          align="center" label="操作" width="200">

        <template slot-scope="scope">
          <el-button
              size="mini"
              @click="handleEdit( scope.row)">
            <i class="el-icon-setting"></i>
            信息维护
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleterole(scope.$index, scope.row)"><i class="el-icon-delete"></i>删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <template>
      <div>
        <pagination
            id="companyListpage"
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>
    <el-dialog :title="selectTable.title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="selectTable" :rules="formRules" ref="selectForm" label-width="100px">
        <el-form-item label="仓库名称:" prop="name">
          <el-input v-model="selectTable.name" auto-complete="off" placeholder="请输入仓库名称"></el-input>
        </el-form-item>

        <el-form-item label="仓库类型:" prop="type">
          <el-select v-model="selectTable.type" placeholder="请选择仓库类型" style="width: 100%;">
            <el-option
                v-for="item in optionskhlx"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="仓库编码:" prop="code">
          <el-input v-model="selectTable.code" auto-complete="off" placeholder="请输入仓库编码"></el-input>
        </el-form-item>

        <el-form-item label="负责人:" prop="principal">
          <el-input v-model="selectTable.principal" auto-complete="off" placeholder="请输入负责人姓名"></el-input>
        </el-form-item>

        <el-form-item label="省:" prop="province">
          <el-select v-model="selectTable.province" placeholder="请选择省" @change="handleProvinceChange" style="width: 100%;">
            <el-option
                v-for="item in optionsSheng"
                :key="item.id"
                :label="item.dictValue"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="市:" prop="city">
          <el-select v-model="selectTable.city" placeholder="请选择市" @change="handleCityChange" style="width: 100%;">
            <el-option
                v-for="item in optionsShi"
                :key="item.id"
                :label="item.dictValue"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="区:" prop="county">
          <el-select v-model="selectTable.county" placeholder="请选择区" style="width: 100%;">
            <el-option
                v-for="item in optionsQu"
                :key="item.id"
                :label="item.dictValue"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="详细地址:" prop="address">
          <el-input v-model="selectTable.address" auto-complete="off" placeholder="请输入详细地址"></el-input>
        </el-form-item>

        <el-form-item label="备注:" prop="remark">
          <el-input v-model="selectTable.remark" auto-complete="off" placeholder="请输入备注（选填）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createtree">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    // 自定义仓库名称校验
    const validateName = (rule, value, callback) => {
      // 去掉空值判断，因为 required 会处理
      if (value && (value.length < 2 || value.length > 30)) {
        callback(new Error('仓库名称长度在 2 到 30 个字符之间'));
      } else {
        callback();
      }
    };

// 自定义仓库编码校验
    const validateCode = (rule, value, callback) => {
      // 去掉空值判断，因为 required 会处理
      if (value && !/^[A-Za-z0-9]+$/.test(value)) {
        callback(new Error('仓库编码只能包含字母和数字'));
      } else if (value && (value.length < 2 || value.length > 20)) {
        callback(new Error('仓库编码长度在 2 到 20 个字符之间'));
      } else {
        callback();
      }
    };

// 自定义负责人校验
    const validatePrincipal = (rule, value, callback) => {
      // 去掉空值判断，因为 required 会处理
      if (value && (value.length < 2 || value.length > 20)) {
        callback(new Error('负责人姓名长度在 2 到 20 个字符之间'));
      } else {
        callback();
      }
    };

// 自定义地址校验
    const validateAddress = (rule, value, callback) => {
      // 去掉空值判断，因为 required 会处理
      if (value && value.length < 5) {
        callback(new Error('地址至少需要5个字符'));
      } else if (value && value.length > 200) {
        callback(new Error('地址不能超过200个字符'));
      } else {
        callback();
      }
    };

    return {
      // 表单校验规则
      formRules: {
        name: [
          { required: true, message: '仓库名称不能为空', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择仓库类型', trigger: 'change' }
        ],
        code: [
          { required: true, message: '仓库编码不能为空', trigger: 'blur' },
          { validator: validateCode, trigger: 'blur' }
        ],
        principal: [
          { required: true, message: '负责人不能为空', trigger: 'blur' },
          { validator: validatePrincipal, trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请选择省', trigger: 'change' }
        ],
        city: [
          { required: true, message: '请选择市', trigger: 'change' }
        ],
        county: [
          { required: true, message: '请选择区', trigger: 'change' }
        ],
        address: [
          { required: true, message: '详细地址不能为空', trigger: 'blur' },
          { validator: validateAddress, trigger: 'blur' }
        ],
        remark: [
          { max: 500, message: '备注不能超过500个字符', trigger: 'blur' }
        ]
      },
      optionsSheng: [],
      optionsShi: [],
      optionsQu: [],
      optionskhlx: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        code : undefined,
        status: 1,
      },
      selectTable: {
        title: '',
        id: 0,
        status: 1,
        name: undefined,
        person: undefined,
        iphone: undefined,
        level: undefined,
        province: undefined,
        city: undefined,
        county: undefined,
        state:1,
      },
      defaultProps: {
        children: "children",
        label: "pname"
      },
      // 菜单列表
      menuOptions: [],
      dialogFormVisible: false,
      dialogFormData: [],
      tableData: [],
      tablelistData: [],
      search: '',
      loading: false
    }
  },
  mounted() {
    this.getList();
    this.getDic("cklx");

  },

  methods: {
    formatWarehouseType(row, column, cellValue) {
      // 从 optionskhlx 中查找对应的 label
      const option = this.optionskhlx.find(item => item.dictCode === cellValue);
      return option ? option.dictValue : cellValue;
    },
    handleProvinceChange(value) {
      this.selectTable.city = null
      this.selectTable.county = null
      this.getShi()

    },
    handleCityChange() {
      this.selectTable.county = null
      this.getQu()
    },
    createtree() {
      this.$refs.selectForm.validate((valid) => {
        if (valid) {
          this.$request.postHttp({
            url: "/basic/saveWarehouseInfo",
            data: JSON.stringify(this.selectTable),
            success: (data) => {
              this.$message.success(data.msg)
              this.dialogFormVisible = false
              this.getList();
            },
            error: (error) => {
              console.error("Error:", error);
              // 执行失败时的操作
            },
          })
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });

    },
    getDic(val) {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: val},
        success: (data) => {
          this.optionskhlx = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getSheng() {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: 'province'},
        success: (data) => {
          this.optionsSheng = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getShi() {
      this.$request.getHttp({
        url: "/system/getMap",
        params: {pid: this.selectTable.province},
        success: (data) => {
          this.optionsShi = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getQu() {
      this.$request.getHttp({
        url: "/system/getMap",
        params: {pid: this.selectTable.city},
        success: (data) => {
          this.optionsQu = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/basic/WarehouseList",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    deleterole(index, row) {
      this.$confirm('确认删除吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$request.postHttp({
          url: "/basic/deleteck",
          params: {rid: row.id},
          success: (data) => {
            this.$message.success('删除成功！')

            this.getList();
          },
          error: (error) => {
            this.$message.error('删除失败！')

            console.error("Error:", error);
            // 执行失败时的操作
          },
        })

      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },
    createdata() {
     this.selectTable=this.$options.data().selectTable
      this.selectTable.title = '添加仓库信息'
      this.dialogFormVisible = true;
      if (this.$refs.selectForm) {
        this.$refs.selectForm.clearValidate()
      }
      this.$refs.selectForm.clearValidate()
      this.getSheng()
    },
    handleEdit(row) {
      this.selectTable.id = row.id
      this.$request.getHttp({
        url: "/basic/getWarehouseInfo",
        params: {id: this.selectTable.id},
        success: (data) => {
          this.selectTable = data.data

          if(this.selectTable.id==null){
            this.selectTable.id=0
          }
          if (this.selectTable.id > 0) {
            this.selectTable.title = '修仓库信息'
          } else {
            this.selectTable.title = '添加仓库信息'
          }
          this.getSheng()
          if (this.selectTable.province > 0) {
            this.getShi()
          }
          if (this.selectTable.city > 0) {
            this.getQu()
          }
          this.$refs.selectForm.clearValidate()
          this.dialogFormVisible = true;
        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })
    },


  },
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

selectupwidth el-select {
  width: 120px;
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/
</style>